import {
  Box,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";

import moment from "moment";
import React, { useCallback, useEffect, useState } from "react";
import FetchHook from "../../Api/FetchHooks";
import { useLocation } from "react-router-dom";
import { formatDate, getUserDetails } from "../../utils/helpers";
import TransactionTable from "../../Components/TransactionTable";
import AlertComponent from "../../Components/AlertComponent";
import Page from "../../Components/Page";
import PageLoader from "../../Components/PageLoader";
import UseServerTable from "../../Hooks/UseServerTable";
import ErrorDisplay from "../../Components/ErrorDisplay";
import { AllInbox } from "@mui/icons-material";

const UserPoolTransactions = ({ _user, showHeader = true }) => {
  const location = useLocation();
  const loggedInUser = getUserDetails();

  const [user, setUser] = useState(
    _user || location?.state?.user || loggedInUser,
  );
  const [data, setData] = useState([]);
  const [status, setStatus] = useState("");

  const [dialog, setDialog] = useState({
    open: false,
    type: null,
    label: null,
  });
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const openDialog = (type, label) => setDialog({ open: true, type, label });
  const closeDialog = () => setDialog({ open: false, type: null, label: null });

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  // const [loading, response, request] = FetchHook();

  // console.log("response", response);

  // const fetchData = useCallback(async () => {
  //   await request({
  //     url: `/wallet_transaction?type=customer_pool_fund&entity_id="${user.id}"`,
  //   });
  // }, [user]);

  // useEffect(() => {
  //   fetchData();
  // }, [fetchData]);

  // useEffect(() => {
  //   if (response && response.status === 200 && response.data.StatusCode === 0) {
  //     setData(response.data.Loan);
  //   }
  // }, [response]);

  const { gridProps, error } = UseServerTable({
    baseUrl: `/wallet_transaction?type=customer_pool_fund&entity_id="${user.id}"`,
    onSuccess: (data) => {
      setData(data.Loan);
    },
  });

  useEffect(() => {
    if (error) {
      setSnackbar({
        open: true,
        message: error.message,
        severity: error.severity,
      });
    }
  }, [error]);

  const columns = [
    {
      field: "transaction_id",
      headerName: "Transaction id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "source_transaction_id",
      headerName: "Source transaction id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "account_number",
      headerName: "Account number",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "loan_id",
      headerName: "Loan id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "global_request_id",
      headerName: "Global request id",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "dr_cr_pair_id",
      headerName: "Dr Cr pair",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "debit",
      headerName: "Debit (money out)",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "credit",
      headerName: "Credit (money in)",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "balance_before",
      headerName: "Balance before",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "balance_after",
      headerName: "Balance after",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "description",
      headerName: "Description",
      minWidth: 300,
      flex: 1,
    },
    {
      field: "transaction_status",
      headerName: "Status",
      minWidth: 170,
      flex: 1,
    },
    {
      field: "transaction_settlement_time",
      headerName: "Transaction settlement time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) => formatDate(params?.value),
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction time",
      minWidth: 170,
      flex: 1,
      valueFormatter: (params) => formatDate(params?.value),
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   renderCell: (row) => (
    //     <Button
    //       variant="contained"
    //       style={{ marginLeft: 16, fontWeight: "bold" }}
    //       disabled={row.row.status === 1 ? false : true}
    //       onClick={() => fixLoanRequest(row.row)}
    //     >
    //       {fixLoading ? "Fixing..." : "Fix request"}
    //     </Button>
    //   ),
    //   width: 200,
    // },
  ];

  const custCols = [
    {
      field: "transaction_id",
      headerName: "Transaction id",
      width: 170,
    },
    {
      field: "debit",
      headerName: "Debit (money out)",
    },
    {
      field: "credit",
      headerName: "Credit (money in)",
    },
    {
      field: "balance_before",
      headerName: "Balance before",
    },
    {
      field: "balance_after",
      headerName: "Balance after",
    },
    {
      field: "description",
      headerName: "Description",
      width: 300,
    },
    {
      field: "transaction_status",
      headerName: "Status",
    },
    {
      field: "transaction_timestamp",
      headerName: "Transaction time",
      width: 170,
      valueFormatter: (params) =>
        moment(params?.value).format("DD/MM/YYYY hh:mm A"),
    },
  ];

  return (
    <Page title={"User Pool Transactions"} showHeader={showHeader}>
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      <Card>
        <CardHeader
          title={
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {showHeader === false && (
                <Typography variant="h6">User Pool Transactions</Typography>
              )}
              {/* <FormControl>
                <InputLabel id="status" size="small">Status</InputLabel>

                <Select
                  labelId="loan_status"
                  id="loan_status"
                  value={status}
                  label="status"
                  onChange={(e) => {
                    setStatus(e.target.value);
                    setCheck(0);
                  }}
                  size="small"
                  defaultValue="active"
                >
                  <MenuItem value="active">Active</MenuItem>
                  <MenuItem value="inactive">Inactive</MenuItem>
                  <MenuItem value="domant">Dormant</MenuItem>
                  <MenuItem value="suspended">Suspended</MenuItem>
                  <MenuItem value="closed">Closed</MenuItem>
                  <MenuItem value="pending">Pending</MenuItem>
                  <MenuItem value="cancelled">Cancelled</MenuItem>
                </Select>
              </FormControl> */}
            </Box>
          }
        />
        <CardContent>
          {gridProps.loading ? (
            <PageLoader />
          ) : data.length > 0 ? (
            <TransactionTable
              data={data}
              // columns={custCols}
              // sortModel={[
              //   {
              //     field: "transaction_timestamp",
              //     sort: "desc",
              //   },
              // ]}
              {...gridProps}
            />
          ) : (
            <ErrorDisplay
              message="You have no transactions!"
              // details="Plesase apply for a loan."
              icon={
                <AllInbox color="secondary" sx={{ mx: "auto", fontSize: 80 }} />
              }
            />
          )}
        </CardContent>
      </Card>
    </Page>
  );
};

export default UserPoolTransactions;
